function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTermsCheckUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.525 7.908a.983.983 0 0 1-.758.325.983.983 0 0 1-.758-.325L.325 4.225a1.047 1.047 0 0 1 0-1.517 1.047 1.047 0 0 1 1.517 0l2.925 2.925L10.075.325a1.047 1.047 0 0 1 1.517 0 1.047 1.047 0 0 1 0 1.517z",
    transform: "translate(6.041 8.212)",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M12 24A11.965 11.965 0 0 1 0 12 11.965 11.965 0 0 1 12 0a11.965 11.965 0 0 1 12 12 11.965 11.965 0 0 1-12 12zm0-21.818a9.778 9.778 0 1 0 6.955 2.864A9.763 9.763 0 0 0 12 2.182z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTermsCheckUnchecked);
export default __webpack_public_path__ + "static/media/icon_terms_check_unchecked.7c48eb71fdb267e1d1762e447f1c0c32.svg";
export { ForwardRef as ReactComponent };